export default function contactCreatePortalUser(data) {
    this.confirm(this.translate('LBL_CONTACT_CREATE_PORTAL_USER_CONFIRM'), () => {
        this.load();
        this.rest.post('contactCreatePortalUser', {record: data.id}, (returnData) => {
            this.unLoad();
            if (returnData.status) {
                if (returnData.errorMessage?.data?.record) {
                    this.popupHide();
                }
                this.error(this.translate(returnData.errorMessage?.text));
            }
        });
    });
}
